import { createFileRoute } from "@tanstack/react-router"

// Import the existing campaign update sku page
import CampaignUpdateSkuPage from "@/pages/jobs/campaigns/update-sku"

export const Route = createFileRoute("/_screen/campaign/affiliate/$id_/update-sku")({
  component: UpdateSkuPage
})

function UpdateSkuPage() {
  const { id } = Route.useParams()
  return <CampaignUpdateSkuPage id={id} />
}
